module.exports = __webpack_public_path__ + "media/theme/continue shopping-81d59052.svg";